import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function issueDrawerClosed(state: WritableDraft<QuoteBuilderStateType>) {
  state.isIssueDrawerOpen = false;
}
